import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

const StyledAnchor = styled(Typography, {
  shouldForwardProp: (prop) => !['underlined'].includes(prop),
})(({ theme, underlined }) => ({
  color: theme.palette.primary.main,
  textDecoration: underlined ? 'underline' : 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export default StyledAnchor;
